import { render, staticRenderFns } from "./SideNav.vue?vue&type=template&id=44feaa64&scoped=true&"
import script from "./SideNav.vue?vue&type=script&lang=ts&"
export * from "./SideNav.vue?vue&type=script&lang=ts&"
import style0 from "./SideNav.vue?vue&type=style&index=0&id=44feaa64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44feaa64",
  null
  
)

export default component.exports